var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button-loader",
    {
      attrs: { loading: _vm.loading, status: _vm.loadingSucceeded },
      on: { finish: _vm.handleFinish },
    },
    [
      _c(
        "button",
        _vm._b(
          {
            ref: "button",
            staticClass: "btn simple-button",
            class: _vm.buttonClass + " " + _vm.className,
            attrs: {
              type: _vm.buttonType,
              disabled: _vm.disabled || _vm.loading,
            },
            on: { click: _vm.handleClick, dblclick: _vm.handleDoubleClick },
          },
          "button",
          _vm.$attrs,
          false
        ),
        [
          _vm.clientLogin
            ? _c("img", {
                attrs: {
                  alt: "",
                  src: require("@Shared/@Assets/img/arrow.svg"),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default", function () {
            return [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")]
          }),
          _vm._v(" "),
          _c("span", { staticClass: "d-none" }, [
            _vm._v(_vm._s(_vm.$t("client-profile.actions.unlinkApplication"))),
          ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }